"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var accounts_client_1 = require("./accounts-client");
Object.defineProperty(exports, "AccountsClient", { enumerable: true, get: function () { return accounts_client_1.AccountsClient; } });
//# sourceMappingURL=index.js.map